import { Text, Flex, Input } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormField } from '../../../components/FormField'
import { FormModal } from '../../../components/FormModal'
import { useAppToast } from '../../../helpers'
import { ISector, SectorService } from '../../../services/Sector/SectorService'

interface IProps {
  isOpen: boolean
  onClose: () => void
  sector: ISector
}

interface IForm {
  name: string
}

export function SectorEditModal({ isOpen, onClose, sector: sector }: IProps) {
  const toast = useAppToast()
  const sectorService = new SectorService()
  const [form, setForm] = useState<IForm>({ name: sector.name })
  const [errors, setErrors] = useState<{ [key: string]: string[] }>({})

  const handleSave = async (event: React.FormEvent) => {
    event.preventDefault()

    if (!formValid()) {
      return
    }

    sectorService
      .update(sector.id, form)
      .then(() => {
        toast.success('Setor editado com sucesso')

        onClose()
      })
      .catch((error) => {
        setErrors(error.response.data.errors)
      })
  }

  const formValid = () => {
    return form.name
  }

  useEffect(() => {
    setForm({ name: sector.name })
  }, [isOpen])

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Editar setor: ${sector.name}`}
      onSubmit={handleSave}
      size="compact"
      isConfirmDisabled={!formValid()}
    >
      <Flex direction="column">
        <FormField label="Nome" error={errors.name} isRequired>
          <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </FormField>
      </Flex>

      {!formValid() && (
        <Text variant="caption" mt={4}>
          Preencha todos os campos acima para prosseguir
        </Text>
      )}
    </FormModal>
  )
}
